import React from 'react'
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  TumblrShareButton,
  TumblrIcon,
  PinterestShareButton,
  PinterestIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import styled from 'styled-components';
import FontsizeOptions from './fontsize-options';

const Frame = styled.div`
margin-bottom: 20px;
margin-top: 10px;
display: grid;
grid-auto-flow: column;
grid-column-gap: 10px;
justify-content: right;
  `;

const ButtonFrame = styled.div`
  position: relative;
  text-align: center;
  cursor: pointer;
  border-radius: 25px;
  &:hover {
    position: relative;
    top: -1px;
    -webkit-box-shadow: 4px 4px 10px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 4px 4px 10px 0px rgba(0,0,0,0.75);
    box-shadow: 4px 4px 10px 0px rgba(0,0,0,0.75);
  }
  `

const ShareArticulo = ({ articulo }) => {
  let shareUrl = window.location.href
  if (shareUrl.endsWith('/articulo/')) shareUrl += articulo.titulo.replace(/ /g, "_").toLowerCase()
  const title = articulo.titulo ? `${articulo.titulo} - Biblioteca de Aerandir. ` : 'Biblioteca de Aerandir. '
  const iconSize = 32
  const body = "Mira este artículo de la Biblioteca de Aerandir: "

  return <Frame>
    <ButtonFrame>
      <TwitterShareButton
        url={shareUrl}
        title={title}
      >
        <TwitterIcon size={iconSize} round />
      </TwitterShareButton>
    </ButtonFrame>
    <ButtonFrame>
      <FacebookShareButton
        url={shareUrl}
        quote={title}
      >
        <FacebookIcon size={iconSize} round />
      </FacebookShareButton>
    </ButtonFrame>
    <ButtonFrame>
      <TumblrShareButton
        url={shareUrl}
        title={title}
      >
        <TumblrIcon size={iconSize} round />
      </TumblrShareButton>
    </ButtonFrame>
    {articulo.imagen && <ButtonFrame><PinterestShareButton
      url={shareUrl}
      media={articulo.imagen}
    >
      <PinterestIcon size={iconSize} round />
    </PinterestShareButton></ButtonFrame>}
    <ButtonFrame>
      <EmailShareButton
        url={shareUrl}
        subject={title}
        body={body}
      >
        <EmailIcon size={iconSize} round />
      </EmailShareButton>
    </ButtonFrame>
    <div style={{ width: 12 }} />
    <FontsizeOptions />
  </Frame>
}


export default ShareArticulo